import { useParams } from "react-router";
import { useHtzReportShowQuery } from "@/services/backend/htz/report/api/report-api";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { TransferLabResultsDialog } from "@/routes/processes/[processId]/htz/reports/[reportId]/microbial/_components/transfer-lab-results-dialog";
import { MicrobialAssessmentsTable } from "@/services/backend/htz/report/components/microbial-assessments-table";

export function MicrobialRoute() {
  const { reportId } = useParams();

  const {
    data: report,
    isLoading,
    error,
  } = useHtzReportShowQuery({ id: reportId! });

  if (isLoading) {
    return <CardSkeleton />;
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (!report) return null;

  return (
    <Card>
      <CardHeader className="relative">
        <CardTitle>{t("Proben")}</CardTitle>
        <div className="absolute top-5 right-6">
          <TransferLabResultsDialog report={report!} />
        </div>
        <CardDescription>
          {t(
            "Die Ergebnisse der Proben können entweder aus den Schnittstellen der Labore abgefragt werden oder manuell eingetragen.",
          )}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <MicrobialAssessmentsTable report={report} />
      </CardContent>
    </Card>
  );
}
